import { useFedopsLogger } from '@wix/yoshi-flow-editor';
import { useFormComponentContext } from './useFormComponentContext';

export const useFedopsLoggerAdapter = () => {
  const fedopsLogger = useFedopsLogger();
  const { isBookingsOnEcom } = useFormComponentContext();

  const interactionStarted = (interactionName: string, ...args: any[]) => {
    fedopsLogger.interactionStarted(interactionName, ...args);
    if (isBookingsOnEcom) {
      fedopsLogger.interactionStarted(`${interactionName}-ecom`, ...args);
    }
  };
  const interactionEnded = (interactionName: string, ...args: any[]) => {
    fedopsLogger.interactionEnded(interactionName, ...args);
    if (isBookingsOnEcom) {
      fedopsLogger.interactionEnded(`${interactionName}-ecom`, ...args);
    }
  };
  return {
    interactionStarted,
    interactionEnded,
  };
};
